export const SAMPLE_LTR_DATA =[{
  id: 1,
  title: "pestion",
  description: "this is the description",
  requester: "Saby the requester",
  team: { id: 1, name: "team 1" },
  sla: 12,
  assigned_to: "Rajy assignee",
  followers: ["follower-1", "follower-2"],
  assignees: ["assignee 1", "assignee 2"],
  // subtasks: { id: number; name: string }[];
  new: false,
  assigned_date: "03/02/2025",
  due_date: "03/02/2025",
  completed_at: "03/02/2025",
  stage_id: 89,
  notes: "this is the ntooesss",

  integrations: [
    {
      avatar:
        "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250403090533-image+14.svg",
      name: "Jira",
    },
    {
      name: "Clickup",
      avatar:
        "https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250403090534-image+15.svg",
    },
  ],
  stages: [
    { id: 1, name: "Stage 1" },
    { id: 2, name: "Stage w2" },
  ],
  current_status: "IN_PROGRESS",

}]